import MyRequestComponent from "../components/MyRequest";
import useMyRequest from "../hooks/useMyRequest";

const MyRequest = ({ isEmployee = false }) => {
  const myRequesttProps = useMyRequest();
  return <MyRequestComponent {...myRequesttProps} isEmployee={isEmployee} />;
};
export default MyRequest;
